import { colorIconStandard } from '@calendly/ui/theme'

import { Svg } from './svg'

export const ProfileIcon = () => (
  <Svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="4" r="3" stroke={colorIconStandard} strokeWidth="2" />
    <path
      d="M8 10C10.4116 10 12.6131 11.3502 13.71 13.4834L13.8125
    13.6924L14.1621 14.4375C14.285 14.6992 14.0938 15 13.8047 15H2.19531C1.94237
    15 1.76489 14.77 1.80664 14.5371L1.83789 14.4375L2.1875 13.6924C3.24526 11.4389
    5.51061 10 8 10Z"
      stroke={colorIconStandard}
      strokeWidth="2"
    />
  </Svg>
)
